import { unitOfTime } from 'moment';

export const last31Days = { duration: 31, unit: 'days' as unitOfTime.DurationConstructor };
export const last31DaysInSeconds = { duration: 31 * 24 * 60 * 60, unit: 'seconds' as unitOfTime.DurationConstructor };

export const last35DaysTimeline = { duration: 35, unit: 'days' as unitOfTime.DurationConstructor };

export const last1Year = { duration: 1, unit: 'years' as unitOfTime.DurationConstructor };
export const last1YearInDays = { duration: 365, unit: 'days' as unitOfTime.DurationConstructor };

export const last2Years = { duration: 2, unit: 'years' as unitOfTime.DurationConstructor };
export const last2YearsInDays = { duration: 365 * 2, unit: 'days' as unitOfTime.DurationConstructor };
